import localStorageService from '../localStorageService/localStorageService.js';

export function isLoggedIn() {
    const token = localStorageService.get("authToken");
    return !!token; // Returns true if a token exists, otherwise false
}